import { FeatureAvailabilityService } from "VSS/FeatureAvailability/Services";

export function getWorkItemsHubId(): string {
    return "ms.vss-work-web.new-work-items-hub";
}
